import { useEffect, useRef } from "react";
import { useState } from "react";
// import { db } from "../dexie";
const Create = ({ onAdd }) => {
  const [text, setText] = useState("");
  const [day, setDay] = useState("");
  const [reminder, setReminder] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd({ text, day, reminder });
    setText("");
    setDay("");
    setReminder(false);
  
  };
 
  const textRef = useRef("");
  const dayRef = useRef("");
  const submitRef = useRef("");
  useEffect(() => {
    textRef.current.focus();
  }, []);
  const handleTextRef = (e) => {
    if (e.key === "Enter") {
      dayRef.current.focus();
    }
  };
  const handleDayRef = (e) => {
    if (e.key === "Enter") {
      submitRef.current.focus();
    }
  };
  const handleSubmitRef = () => {
    console.log("Task submited");
  };

  return (
    <form className="add-form" onSubmit={handleSubmit}>
      <div className="form-control">
        <label>Task</label>
        <input
          type="text"
          onKeyDown={handleTextRef}
          ref={textRef}
          required
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>
      <div className="form-control">
        <label>Day & Time</label>
        <input
          type="text"
          ref={dayRef}
          onKeyDown={handleDayRef}
          placeholder="Add Day & Time"
          value={day}
          required
          onChange={(e) => setDay(e.target.value)}
        />
      </div>
      <div className="form-control form-control-check">
        <label> Set Reminder</label>
        <input
          type="checkbox"
          checked={reminder}
          value={reminder}
          onChange={(e) => setReminder(e.currentTarget.checked)}
        />
      </div>
      <button
        onKeyDown={handleSubmitRef}
        ref={submitRef}
        className=" btn btn-block"
      >
        Add Blog
      </button>
    </form>
  );
};
export default Create;
